<template>
  <div>
    <table-widget
      :items="collaborators"
      :perPage="perPage"
      :totalRows="totalRows"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <template slot="buttons">
        <b-button
          v-if="manage"
          class="mx-2"
          variant="primary"
          v-b-modal.project-collaborators-modal
          @click="selectedCommunityPartners = null"
          ><font-awesome-icon icon="plus" /> Manage Collaborators</b-button
        >
      </template>
      <template slot="content">
        <b-table
          striped
          :items="collaborators"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          small
          show-empty
          empty-filtered-text="There are no collaborators that match your search criteria."
        >
          <template v-slot:cell(name)="data">
            <router-link
              :to="{
                name: 'researchCollaborator',
                params: { asuriteId: data.item.employee.asuriteId },
              }"
              >{{ data.item.employee.firstName }}
              {{ data.item.employee.lastName }}</router-link
            >
          </template>
          <template v-slot:cell(email)="data">
            <a :href="'mailto:' + data.item.email">{{
              data.item.employee.email
            }}</a>
          </template>
          <template v-slot:cell(role)="data">
            {{
              data.item.projectCollaboratorRole
                ? data.item.projectCollaboratorRole.name
                : ""
            }}
          </template>
          <template v-slot:cell(details)="data">
            <router-link
              :to="{
                name: 'researchCollaborator',
                params: { asuriteId: data.item.employee.asuriteId },
              }"
              >Details</router-link
            >
          </template>
        </b-table>
      </template>
    </table-widget>
    <b-modal
      id="project-collaborators-modal"
      title="Add Collaborators"
      v-model="showForm"
      hide-footer
    >
      <b-form class="form-horizontal" @submit="save">
        <b-form-group label="" label-class="control-label">
          <autocomplete-form
            v-model="items"
            :displayFunction="userDisplay"
            :tableDisplayFunction="tableDisplay"
            :selectFunction="update"
            apiPath="/api/users/findldap?search="
            objectName="Collaborator"
            objectKey="employeeId"
          >
            <template slot="fields">
              <b-form-group label="" label-class="control-label">
                <b-form-select
                  v-model="selectedRole"
                  :options="roles"
                  value-field="id"
                  placeholder="Select a role"
                  text-field="name"
                >
                  <template slot="first">
                    <option :value="null">Select a role or leave blank</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </template>
            <template slot="buttons">
              <div class="modal-footer">
                <b-btn variant="secondary" @click="showForm = false"
                  >Cancel</b-btn
                >
                <b-btn type="submit" variant="primary">Save</b-btn>
              </div>
            </template>
          </autocomplete-form>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import TableWidget from "../table-widget";
import AutocompleteFormWrapper from "../autocomplete-form-wrapper";
import ProjectApi from "../../api/projects";

export default {
  data() {
    return {
      items: [],
      selectedRole: null,
      roles: [],
      fields: [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "role", label: "Role" },
        { key: "details", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      showForm: false,
    };
  },

  props: {
    collaborators: {
      type: Array,
      required: true,
    },
    manage: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
  },

  components: {
    "table-widget": TableWidget,
    "autocomplete-form": AutocompleteFormWrapper,
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    userDisplay: function (user) {
      return (
        user.firstName +
        " " +
        user.lastName +
        " (" +
        user.asuriteId +
        ") - " +
        user.department +
        " - " +
        user.title
      );
    },
    tableDisplay: function (user) {
      return (
        user.employee.firstName +
        " " +
        user.employee.lastName +
        " (" +
        user.employee.asuriteId +
        ")" +
        (user.projectCollaboratorRole
          ? " - " + user.projectCollaboratorRole.name
          : "")
      );
    },
    update(autoselectResponse) {
      var found = _.find(this.items, (selectedItem) => {
        return (
          selectedItem.employee.asuriteId ===
          autoselectResponse.selectedObject.asuriteId
        );
      });
      if (!found) {
        var role = _.find(this.roles, (role) => {
          return role.id === this.selectedRole;
        });
        this.items.push({
          projectCollaboratorRoleId: this.selectedRole
            ? this.selectedRole
            : null,
          projectCollaboratorRole: this.selectedRole
            ? {
                id: this.selectedRole ? this.selectedRole : 0,
                name: role ? role.name : "",
              }
            : null,
          employee: autoselectResponse.selectedObject,
        });
      }
      this.$emit("input", this.items);
    },
    save() {
      event.preventDefault();
      this.$emit("save", this.items);
      this.showForm = false;
    },
  },
  watch: {
    collaborators: function () {
      if (this.collaborators) {
        this.items = _.clone(this.collaborators);
      }
    },
  },
  created() {
    if (this.collaborators) {
      this.items = _.clone(this.collaborators);
    }
    ProjectApi.getRoles().then((response) => {
      this.roles = response.data;
    });
  },
};
</script>

<style scoped>
table {
  font-size: 10pt;
}
</style>
